import {
  getProgressReportsMockHandler,
  getTeacherRemarksMockHandler,
} from '@/features/module-reports/api';

export const moduleReportsHandlers = [
  getTeacherRemarksMockHandler,
  getProgressReportsMockHandler,
];
